// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__xOEXf","question":"Question_question__3DBNS","description":"Question_description__cdrrg"};